<template>
	<p>Scheda Paziente</p>
</template>

<script>
export default {};
</script>

<style></style>
